var _circle, _rect, _g, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddTrip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 61,
    viewBox: "0 0 246 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.7344,
    cy: 30.75,
    r: 30,
    fill: "#9C4900"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_812_737",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 41,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.7344,
    y: 10.75,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_812_737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7306 27.841C38.4006 27.8413 38.0804 27.7291 37.8226 27.523C36.6505 26.5843 35.677 25.4216 34.959 24.1026C34.241 22.7837 33.7928 21.335 33.6406 19.841C33.6406 18.4908 34.177 17.1959 35.1317 16.2411C36.0865 15.2864 37.3814 14.75 38.7316 14.75C40.0818 14.75 41.3768 15.2864 42.3315 16.2411C43.2863 17.1959 43.8226 18.4908 43.8226 19.841C43.6705 21.335 43.2223 22.7837 42.5043 24.1026C41.7863 25.4216 40.8128 26.5843 39.6406 27.523C39.3829 27.7291 39.0626 27.8413 38.7326 27.841H38.7306ZM38.7306 17.659C38.1521 17.6595 37.5974 17.8896 37.1883 18.2987C36.7792 18.7078 36.5492 19.2625 36.5486 19.841C36.7107 21.5646 37.4848 23.173 38.7306 24.375C39.9769 23.1725 40.751 21.5633 40.9126 19.839C40.9121 19.2605 40.682 18.7058 40.2729 18.2967C39.8639 17.8876 39.3092 17.6575 38.7306 17.657V17.659Z",
    fill: "#F6EFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7306 46.7472C22.4006 46.7475 22.0804 46.6354 21.8226 46.4293C20.6505 45.4905 19.677 44.3278 18.959 43.0089C18.241 41.6899 17.7928 40.2412 17.6406 38.7473C17.6406 37.397 18.177 36.1021 19.1317 35.1474C20.0865 34.1926 21.3814 33.6562 22.7316 33.6562C24.0818 33.6562 25.3768 34.1926 26.3315 35.1474C27.2863 36.1021 27.8226 37.397 27.8226 38.7473C27.6705 40.2412 27.2223 41.6899 26.5043 43.0089C25.7863 44.3278 24.8128 45.4905 23.6406 46.4293C23.3829 46.6354 23.0626 46.7475 22.7326 46.7472H22.7306ZM22.7306 36.5652C22.1521 36.5658 21.5974 36.7958 21.1883 37.2049C20.7792 37.614 20.5492 38.1687 20.5486 38.7473C20.7079 40.475 21.4822 42.0882 22.7306 43.2933C23.9769 42.0908 24.751 40.4815 24.9126 38.7573C24.9121 38.1787 24.682 37.624 24.2729 37.2149C23.8639 36.8058 23.3092 36.5758 22.7306 36.5752V36.5652Z",
    fill: "#F6EFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2794 42.3814H30.7334C30.3475 42.3814 29.9774 42.2281 29.7046 41.9552C29.4317 41.6823 29.2784 41.3123 29.2784 40.9264C29.2784 40.5405 29.4317 40.1704 29.7046 39.8975C29.9774 39.6247 30.3475 39.4714 30.7334 39.4714H37.2794C38.2437 39.4714 39.1686 39.0883 39.8504 38.4064C40.5323 37.7245 40.9154 36.7997 40.9154 35.8354C40.9154 34.871 40.5323 33.9462 39.8504 33.2643C39.1686 32.5825 38.2437 32.1994 37.2794 32.1994H24.1894C22.4734 32.1694 20.8378 31.4666 19.6348 30.2425C18.4319 29.0183 17.7578 27.3707 17.7578 25.6544C17.7578 23.9381 18.4319 22.2904 19.6348 21.0663C20.8378 19.8421 22.4734 19.1394 24.1894 19.1094H30.0074C30.3933 19.1094 30.7634 19.2627 31.0362 19.5355C31.3091 19.8084 31.4624 20.1785 31.4624 20.5644C31.4624 20.9503 31.3091 21.3204 31.0362 21.5932C30.7634 21.8661 30.3933 22.0194 30.0074 22.0194H24.1894C23.2251 22.0194 22.3002 22.4025 21.6184 23.0843C20.9365 23.7662 20.5534 24.691 20.5534 25.6554C20.5534 26.6197 20.9365 27.5445 21.6184 28.2264C22.3002 28.9083 23.2251 29.2914 24.1894 29.2914H37.2794C38.9954 29.3214 40.631 30.0241 41.834 31.2483C43.0369 32.4724 43.711 34.1201 43.711 35.8364C43.711 37.5527 43.0369 39.2003 41.834 40.4245C40.631 41.6486 38.9954 42.3514 37.2794 42.3814Z",
    fill: "#F6EFE9"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 62.2344,
    y1: 30.25,
    x2: 244.234,
    y2: 30.25,
    stroke: "#8F4300",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTrip);
export default __webpack_public_path__ + "static/media/add_trip.26c8d8293dd94bd9712625dea542ee5f.svg";
export { ForwardRef as ReactComponent };